var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Propiedades")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'agre-propi'}}},[_vm._v("Agregar")]),_vm._v(" "),(_vm.propiedadesTodas !=null)?_c('ul',{attrs:{"id":"propiedades-lista"}},_vm._l((_vm.propiedadesTodas),function(propi){return _c('li',[_c('strong',[_vm._v(_vm._s(propi.nombreCompleto)+" "+_vm._s(propi.familia)+" "+_vm._s(propi.tipo))])])}),0):_c('span',[_vm._v("Cargando propiedades...")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b0ac1ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Propiedad-seleccionar.vue
// module id = 155
// module chunks = 0